import { Instagram, CalendarClock, Monitor } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { IG_PROFILE } from "../lib/api";
import { PageHeader, card } from "../components/PageHeader";

export default function Contact() {
  const { user } = useAuth();
  return (
    <div className="space-y-6" data-testid="contact-page">
      <PageHeader title="İletişim" subtitle="Lisans yenileme ve destek için bize Instagram'dan ulaşın." />
      <div className="grid gap-6 lg:grid-cols-5">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-fuchsia-600 via-pink-500 to-orange-400 p-8 text-white shadow-lg lg:col-span-3">
          <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-white/15 blur-2xl" />
          <Instagram className="h-12 w-12" />
          <h2 className="mt-4 font-heading text-3xl font-extrabold">@kasamnetcom</h2>
          <p className="mt-2 max-w-md text-white/90">Lisansınızı yenilemek veya uzatmak için Instagram hesabımıza mesaj gönderin. Kullanıcı adınızı (<b>@{user.username}</b>) yazmayı unutmayın.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a data-testid="contact-instagram-profile-link" href={IG_PROFILE} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-3 font-semibold text-pink-600 shadow transition-transform active:scale-95">
              <Instagram className="h-5 w-5" /> Instagram Profiline Git
            </a>
          </div>
        </div>
        <div className={`${card} lg:col-span-2`} data-testid="contact-license-info">
          <div className="flex items-center gap-2 text-slate-900"><CalendarClock className="h-5 w-5 text-cyan-700" /><h3 className="font-heading text-lg font-bold">Lisans Bilgileriniz</h3></div>
          <dl className="mt-4 space-y-3 text-sm">
            <div className="flex justify-between"><dt className="text-slate-500">Kullanıcı</dt><dd className="font-semibold">{user.first_name} {user.last_name}</dd></div>
            <div className="flex justify-between"><dt className="text-slate-500">Başlangıç</dt><dd className="font-semibold">{new Date(user.license_start).toLocaleDateString("tr-TR")}</dd></div>
            <div className="flex justify-between"><dt className="text-slate-500">Bitiş</dt><dd className="font-semibold">{new Date(user.license_end).toLocaleDateString("tr-TR")}</dd></div>
            <div className="flex justify-between"><dt className="text-slate-500">Kalan</dt>
              <dd className={`font-bold ${!user.license_active ? "text-rose-600" : user.days_left <= 30 ? "text-amber-600" : "text-emerald-600"}`}>
                {user.license_active ? `${user.days_left} gün` : "Süresi doldu"}
              </dd></div>
          </dl>
          {!navigator.userAgent.includes("Electron") && (
            <a href="/download/KasamNet-Setup.exe" download data-testid="contact-windows-download-link"
              className="mt-6 flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-cyan-600 to-blue-800 py-2.5 text-sm font-semibold text-white">
              <Monitor className="h-4 w-4" /> Windows Uygulamasını İndir
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
